import { Award } from "lucide-react";

export const FounderBadge = ({ estado, testid = "founder-badge" }) => (estado?.es_fundador ? (
  <span data-testid={testid} className="inline-flex items-center gap-1 text-[11px] font-bold px-2 py-0.5 rounded-full bg-[#bc9538]/15 text-[#9a7622] dark:text-[#e2c47a] border border-[#bc9538]/40">
    <Award className="w-3.5 h-3.5" /> Fundador #{estado.numero_fundador}
  </span>
) : null);
